import { ButtonEnum } from "designSystem/types/button-types";
import { Button, Grid, Message, PopupDialog } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { usePresentationPageStore } from "./main";
import PPValidationCenter from "./Validation/PPValidationCenter";
import { PPValidationStoreContext } from "./Validation/PPValidationStore";

const PPBanner: FunctionComponent = observer(() => {
	// include this to make the banner re-render once the page node changes
	const { pageStore } = useStore();
	const { primaryType, violationUrls, validationStore, recalculateViolations, isPresentationEditor } = usePresentationPageStore();
	const loc = useLocale();
	const numberText = loc.numberOfType(violationUrls.size, primaryType);

	const { setOpen, reset, open, resolveProduct, hasChanges, isTheLastItem } = validationStore || {};

	/** the handler of onClose */
	const onClose = () => {
		reset();

		if (hasChanges) {
			recalculateViolations();
		}
	};

	/** open the validation center dialog */
	const onOpen = () => {
		setOpen(true);
	};

	/** apply and close */
	const applyAndClose = async () => {
		const madeChanges = await resolveProduct(true);

		if (madeChanges) {
			recalculateViolations();
		}
	};

	/** apply and next */
	const applyAndNext = () => {
		resolveProduct();
	};

	return (
		<>
			{violationUrls?.size > 0 && (
				<Message
					titleRes="PresentationInvalidProductsMessageForPPBanner"
					titleResParams={[numberText]}
					variant="banner"
				>{{
						buttons: (
							<Grid container>
								<Grid item>
									{isPresentationEditor && (
										<Button
											design="secondary"
											onClick={onOpen}
											res="ViewAll"
										/>
									)}
									{open && (
										<PPValidationStoreContext.Provider value={validationStore}>
											<PopupDialog
												contentSpacing={0}
												fullHeight
												fullWidth
												onClose={onClose}
												open
												titleRes="PresentationValidationCenter"
											>
												{{
													main: <PPValidationCenter />,
													buttons: (
														<>
															<Button
																design={isTheLastItem ? "primary" : "secondary"}
																onClick={applyAndClose}
																res="BUTTON_APPLY_AND_CLOSE"
															/>
															{!isTheLastItem && (
																<Button
																	design="primary"
																	onClick={applyAndNext}
																	res="BUTTON_APPLY_AND_NEXT"
																/>
															)}
															<Button
																design="link"
																onClick={onClose}
																res={ButtonEnum.BUTTON_CANCEL}
															/>
														</>
													),
												}}
											</PopupDialog>
										</PPValidationStoreContext.Provider>
									)}
								</Grid>
							</Grid>
						),
					}}
				</Message>
			)}
		</>
	);
});

export default PPBanner;